import { context } from 'auth';
import { get } from 'fetch-api';

let baseUrl = 'referrals';

export const NBXReferral = {
  init: config => ({ baseUrl } = config),

  getReferralCode: () =>
    context
      .account()
      .then(account =>
        (get(`${baseUrl}/code`, account) as Promise<{ code: string }>).then(({ code }) => code)
      )
};
